export const SUCCESS = 'success';
export const ERROR = 'failure';
export const IN_PROGRESS = 'in-progress';
export const RESET = 'reset';